export default __webpack_public_path__ + "static/media/BOD Regular Meeting 16 February 2021.12cc93c2.pdf";